import { createUrl } from "@touchtech/web-api-client";

import { getEnvValue } from "@is/utils/env";

const baseUrl = getEnvValue("VITE_INSTORE_CLOUD_SERVICE_URL");

export const createCheckoutConfigurationsUrl = () =>
  createUrl(baseUrl, `api/checkoutConfigurations/options`);

export const createCheckoutConfigurationsByTypeUrl = (type: string) =>
  createUrl(baseUrl, `api/checkoutConfigurations/options/by-type/${type}`);

export const createCheckoutConfigurationsValidationUrl = () =>
  createUrl(baseUrl, `api/checkoutConfigurations/options/validate`);
